import script from "./Page404.vue?vue&type=script&setup=true&lang=js"
export * from "./Page404.vue?vue&type=script&setup=true&lang=js"

import "./Page404.vue?vue&type=style&index=0&id=1c19c232&lang=scss"

const __exports__ = script;

export default __exports__